import { VStack } from '@chakra-ui/layout';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

function Demo() {
  return (
    <VStack my={8} alignItems="center">
      <Tabs variant="soft-rounded" colorScheme="brand">
        <TabList justifyContent="center">
          <Tab>Desktop</Tab>
          <Tab>Mobile</Tab>
        </TabList>
        <TabPanels mt={4}>
          <TabPanel>
            <video width="800" height="100%" controls>
              <source src="/files/student_demo_desktop.mp4" type="video/mp4" />
            </video>
          </TabPanel>
          <TabPanel>
            <video width="300" height="100%" controls>
              <source src="/files/student_demo_mobile.mp4" type="video/mp4" />
            </video>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </VStack>
  );
}

export default Demo;
